import { type LocalStorageKey } from './constants';

const appStorageKey = `baobab_${import.meta.env.MODE}`;

export const getInLocalStorage = () =>
  JSON.parse(localStorage.getItem(appStorageKey) ?? '{}');

export const getInLocalStorageByKey = (key: LocalStorageKey) =>
  getInLocalStorage()[key];

export const setInLocalStorage = (key?: LocalStorageKey, value?: any) => {
  const currentLocalStorage = getInLocalStorage();
  if (key) currentLocalStorage[key] = value;

  localStorage.setItem(appStorageKey, JSON.stringify(currentLocalStorage));
};
